import React,{useState,useRef,Fragment} from "react";
import {
  Button,
  Modal,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaEye, FaEyeSlash } from "react-icons/fa";
const ChangePasswordModal = ({
  openModal,
  toggleModal,
  onchangeInputField,
  handleSubmitPassword,
  currentpassword,
}) => {
  // Function -------------------------
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordMatch, setPasswordMatch] = useState(true);
  const [currentpasswordMatch, setCurrentPasswordMatch] = useState(true);
  const [isRevealPwd, setIsRevealPwd] = useState(false);
  const [isRevealNewPwd, setIsRevealNewPwd] = useState(false);
  const [isRevealConfirmPwd, setIsRevealConfirmPwd] = useState(false);
  const eye = <FontAwesomeIcon icon={FaEye} />;
  var loginUser = JSON.parse(localStorage.getItem("user"));
  const handlePasswordChange = (e) => {
    onchangeInputField(e);
    setPassword(e.target.value);
  };
  const togglePasswordVisiblity = () => {
    setIsRevealPwd(prevState => !prevState);
  };
  const toggleNewPasswordVisiblity = () => {
    setIsRevealNewPwd(prevState => !prevState);
  };
  const toggleConfirmPasswordVisiblity = () => {
    setIsRevealConfirmPwd(prevState => !prevState);
  };
  const handleConfirmPasswordChange = (e) => {
    onchangeInputField(e);
    setConfirmPassword(e.target.value);
  };
  const handleCurrentPasswordChange = (e) => {
    onchangeInputField(e);
    setCurrentPasswordMatch(e.target.value);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    // if(currentpassword !== currentpasswordMatch)
    //   {
    //  setCurrentPasswordMatch(false);
    //   }
   if (password === confirmPassword) {
      handleSubmitPassword();
    } else {
   
      setPasswordMatch(false);
    }
  };

  return (
    <div>
      <Modal isOpen={openModal} toggle={toggleModal}>
        {/* <ModalHeader toggle={toggleModal}>Modal title</ModalHeader> */}
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="exampleEmail">Current Password</Label>
              <InputGroup>
              <Input
                type={isRevealPwd ? "text" : "password"}
                name="currentPassword"
                id="currentPassword"
                placeholder="Enter Current Password"
                onChange={(e) => handleCurrentPasswordChange(e)}
              />
               <InputGroupText onClick={togglePasswordVisiblity} style={{ cursor: "pointer" }}>
        {isRevealPwd ? <FaEye />  : <FaEyeSlash />}
      </InputGroupText>
              </InputGroup>
              {/* {!currentpasswordMatch && <p style={{ color: 'red' }}>Incorrect Passwords..</p>} */}
              <Label for="exampleEmail">New Password</Label>
              <InputGroup>
              <Input
                type={isRevealNewPwd ? "text" : "password"}
                name="newPassword"
                id="newPassword"
                placeholder="Enter New Password"
                onChange={(e) => handlePasswordChange(e)}
              />
              <InputGroupText onClick={toggleNewPasswordVisiblity} style={{ cursor: "pointer" }}>
        {isRevealNewPwd ? <FaEye />  :<FaEyeSlash /> }
      </InputGroupText>
              </InputGroup>
               <Label for="exampleEmail">Confirm Password</Label>
               <InputGroup>
              <Input
                type={isRevealConfirmPwd ? "text" : "password"}
                name="confirmPassword"
                id="confirmPassword"
                placeholder="Confirm Password"
                onChange={(e) => handleConfirmPasswordChange(e)}
              />
              <InputGroupText onClick={toggleConfirmPasswordVisiblity} style={{ cursor: "pointer" }}>
              {isRevealConfirmPwd ? <FaEye />  :<FaEyeSlash /> }
              </InputGroupText>
              </InputGroup>
              {!passwordMatch && <p style={{ color: 'red' }}>Passwords do not match</p>}
            </FormGroup>
            <Button outline color="info" onClick={(e) =>handleSubmit(e)}>
              Update
            </Button>{" "}
            <Button outline color="danger" onClick={toggleModal}>
              Cancel
            </Button>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default ChangePasswordModal;
